import { useState } from 'react';
import { Button, Modal } from '@icebreaker/ui';
import { useTranslation } from '@/shared/i18n/i18n-provider';
import { PasswordForm } from './password-form';
import styles from './staff-access.module.css';

/**
 * "ŞİFREYİ DEĞİŞTİR" — panelin hesap menüsündeki giriş noktası.
 *
 * ROTA AÇILMADI, DİYALOG SEÇİLDİ: şifre değiştirme bir EKRAN değil, hesap
 * eylemidir; kendi adresi olsaydı yan gezinmede bir satır daha açmak
 * gerekirdi (`route-reachability.guard`) ve gezinme yönetim ekranlarıyla
 * hesap ayarlarını karıştırırdı. Kabuğun hesap bölgesinde durur, tıklanınca
 * kitin `Modal`ını açar.
 *
 * Düğme bileşenin İÇİNDEDİR: kabuk yalnız tek satır çağırır, durum burada
 * yaşar (kabukta diyalog durumu tutmak onu her ekran için yeniden çizerdi).
 */
export function ChangePasswordButton() {
  const t = useTranslation();
  const [open, setOpen] = useState(false);
  // Kaydedilince diyalog sessizce kapanmaz, onay cümlesi kalır (sıra 144).
  const [saved, setSaved] = useState(false);
  const close = () => {
    setOpen(false);
    setSaved(false);
  };

  return (
    <>
      <Button variant="ghost" size="sm" onClick={() => setOpen(true)}>
        {t.t('admin.panel.password.changeAction')}
      </Button>
      <Modal
        open={open}
        title={t.t('admin.panel.password.changeTitle')}
        closeLabel={t.t('admin.panel.password.close')}
        onClose={close}
        footer={
          saved ? (
            <Button variant="ghost" onClick={close}>
              {t.t('admin.panel.password.close')}
            </Button>
          ) : undefined
        }
      >
        {saved ? (
          <p className={styles.saved} role="status">
            {t.t('admin.panel.password.saved')}
          </p>
        ) : (
          <PasswordForm
            idPrefix="panel-change-password"
            submitLabel={t.t('admin.panel.password.save')}
            secondaryAction={
              <Button type="button" variant="ghost" onClick={close}>
                {t.t('admin.panel.password.cancel')}
              </Button>
            }
            onSaved={() => setSaved(true)}
          />
        )}
      </Modal>
    </>
  );
}
